
import { defineComponent } from 'vue';

// Components
import DotsLoader from '../dots-loader/dots-loader.vue';
// Helpers
import { isBookingPortalFlow } from '@white-label-helper/booking-portal-flow';


export default defineComponent({
  components: {
    DotsLoader,
  },
  computed:{
    isBookingPortalFlowEnabled(): boolean {
      return isBookingPortalFlow();
    },
  }
});
